import { ClientContext } from '~lib/platform/ltm/types';

export const gatherClientContext = (): ClientContext => ({
	channel: 'direct',
	channelPartner: '',
	version: typeof window === 'undefined' ? 'local' : window.cuvva.deployment.gitCommit,
	platform: 'web',
});
